import type { QuoteFile } from 'paintscout'

/**
 * A multi-file upload reports one entry per file, and a *failed* one is the thrown error itself
 * rather than a file (see `useFileDropArea`'s `allUploadRes.push(err)`), so every consumer of that
 * array has to drop the non-files before using it. A file with no `src` is equally useless to a
 * gallery tile or a library entry, so it goes too.
 */
export function getUploadedFiles(files: unknown[]): QuoteFile[] {
  if (!Array.isArray(files)) return []
  return files.filter(
    (file): file is QuoteFile =>
      !!file && typeof file === 'object' && !(file instanceof Error) && !!(file as QuoteFile).src
  )
}
